// extracted by mini-css-extract-plugin
module.exports = {"container":"PaymodesFooter_ketogo_container__4ntKa","title":"PaymodesFooter_ketogo_title__17skl"};